import { useState } from 'react'
import styled from 'styled-components'

interface IProps {
  placeholder: string
}

export default function TextInput({ placeholder }: IProps) {
  const [value, setValue] = useState<string>(placeholder)

  return <Container onChange={(event) => setValue(event.target.value)} type="text" value={value} />
}

const Container = styled.input`
  align-items: center;
  background-color: #ffffff;
  border: none;
  border-radius: 4px;
  color: #000000;
  display: flex;
  flex-direction: column;
  height: 28px;
  justify-content: flex-start;
  text-align: center;
  width: 100%;
`
